import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TableBody, TableHead, TableHeader, TableRow, Table as UITable } from '@repo/ui-primitives/table';
export const Table = (param)=>{
    let { headerItems, children, className } = param;
    return /*#__PURE__*/ _jsxs(UITable, {
        className: className,
        children: [
            /*#__PURE__*/ _jsx(TableHeader, {
                children: /*#__PURE__*/ _jsx(TableRow, {
                    children: headerItems.map((header)=>/*#__PURE__*/ _jsx(TableHead, {
                            align: header.align,
                            width: header.width,
                            children: header.title
                        }, header.id))
                })
            }),
            /*#__PURE__*/ _jsx(TableBody, {
                children: children
            })
        ]
    });
};
